import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import './Technology.scss'
class Technology extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Technologybanner.png"), imgHDPath: `${require("img/EcosphereDetails/Technologybanner.png")} 1x,${require("img/EcosphereDetails/Technologybanner@2x.png")} 2x,${require("img/EcosphereDetails/Technologybanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists02: [
        {
          title: 'EveryBIM协同管理平台',
          data: 'EveryBIM协同管理平台，包含协同管理和智慧工地，是围绕BIM打造的工程现场管控平台，可协助施工单位管控现场，进行高效管理。',
          imgPath: require("img/EcosphereDetails/Technologyicon01.png"), imgHDPath: `${require("img/EcosphereDetails/Technologyicon01.png")} 1x,${require("img/EcosphereDetails/Technologyicon01@2x.png")} 2x,${require("img/EcosphereDetails/Technologyicon01@3x.png")} 3x`
        },
        {
          title: 'BIM图形引擎',
          data: 'BIM图形引擎是专为AEC行业打造的BIM轻量化开发组件，具有多源BIM数据格式集成能力，具备业内领先的轻量化能力，拥有强大的跨平台图形功能。BIM图形引擎能帮助开发者在短期内搭建出商业级的3D可视化BIM应用程序。',
          imgPath: require("img/EcosphereDetails/Technologyicon02.png"), imgHDPath: `${require("img/EcosphereDetails/Technologyicon02.png")} 1x,${require("img/EcosphereDetails/Technologyicon02@2x.png")} 2x,${require("img/EcosphereDetails/Technologyicon02@3x.png")} 3x`
        },
        {
          title: '青矩全咨云平台',
          data: '青矩全咨云平台是基于BIM技术的新一代全过程工程咨询管理平台，以BIM模型为数字化载体，开展项目管理、投资控制、多方协同，帮助业主、咨询单位更精准把控工程投资、更高效开展项目管理。',
          imgPath: require("img/EcosphereDetails/Technologyicon03.png"), imgHDPath: `${require("img/EcosphereDetails/Technologyicon03.png")} 1x,${require("img/EcosphereDetails/Technologyicon03@2x.png")} 2x,${require("img/EcosphereDetails/Technologyicon03@3x.png")} 3x`
        },
        {
          title: 'BIM应用咨询',
          data: '将BIM技术应用于工程建设全生命周期，为工程相关企业提供BIM整体解决方案；聚焦行业前沿，开展BIM课题研究、标准研究，为工程建设赋能。',
          imgPath: require("img/EcosphereDetails/Technologyicon04.png"), imgHDPath: `${require("img/EcosphereDetails/Technologyicon04.png")} 1x,${require("img/EcosphereDetails/Technologyicon04@2x.png")} 2x,${require("img/EcosphereDetails/Technologyicon04@3x.png")} 3x`
        },
      ],
    }
  }
  render() {
    return (
      <main className="Development-container">
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Development">
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists02}></Lists>
        </div>
      </main>
    )
  }
}
export default Technology
